export default __webpack_public_path__ + "static/media/logo-md-dark.2c146cbf.png";